define('viewModels/privileged/qm/CustomerJourneyView',[
    'lib/knockout',
    'lib/lodash4',
    'viewModels/ViewModel',
    'viewModels/SwitchedView',
    'viewModels/privileged/qm/CustomerJourneyListView',
    'viewModels/privileged/qm/CustomerJourneyDetailsView',
    'services/navHelper'
], function (
    ko,
    _,
    ViewModel,
    SwitchedView,
    CustomerJourneyListView,
    CustomerJourneyDetailsView,
    navHelper
) {
    'use strict';

    /**
     * @class CustomerJourneyView
     *
     * @param  {JourneyContext[]} journeyContexts
     * @param  {string} sessionId (optional) the sessionId to show. Will render a CustomerJourneyDetailsView if provided.
     */
    return ViewModel.extend(function CustomerJourneyView (journeyContexts, activeCustomerJourneySessionId) {
        var self = this;

        self.subViews = self.subView(SwitchedView, {
            customerJourneyList: CustomerJourneyListView,
            customerJourneyDetails: CustomerJourneyDetailsView
        });

        self.activeCustomerJourneySessionId = ko.observable(activeCustomerJourneySessionId);

        var navigateToCustomerJourneySession = function (sessionId) {
            // will not include any hash query params
            // (i.e., query params occuring after the hash in the URL)
            // assumes we're on the interaction details route, agent or admin.
            var path = window.location.hash.replace(/journeys\/.+/, 'journeys');
            if (sessionId) {
                path = path.concat('/' + sessionId);
            }
            navHelper.navigateTo(path);
            self.activeCustomerJourneySessionId(sessionId);
        };

        var navigateToJourneysList = navigateToCustomerJourneySession.bind(self, null);

        /**
         * @param  {string} newCustomerJourneySessionId
         */
        var updateActiveView = function (newCustomerJourneySessionId) {
            if (newCustomerJourneySessionId) {
                var journeyContext = _.find(journeyContexts, { journeyCustomerSessionId: newCustomerJourneySessionId });
                self.subViews.setActiveView('customerJourneyDetails', journeyContext, navigateToJourneysList);
            } else {
                self.subViews.setActiveView('customerJourneyList', journeyContexts, navigateToCustomerJourneySession);
            }
        };

        updateActiveView(activeCustomerJourneySessionId);

        self.subscribe(self.activeCustomerJourneySessionId, updateActiveView);
    });
});
